<template>
  <div></div>
</template>

<script>
export default {
  name: 'detail',
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
